export default "__VITE_ASSET__BK7OjVWE__"